import { render } from "./taxNeimengQtsr.vue?vue&type=template&id=32b8f27e&scoped=true"
import script from "./taxNeimengQtsr.vue?vue&type=script&lang=js"
export * from "./taxNeimengQtsr.vue?vue&type=script&lang=js"

import "./taxNeimengQtsr.vue?vue&type=style&index=0&id=32b8f27e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b8f27e"]])

export default __exports__